import { useInfiniteQuery, useQuery } from "@tanstack/react-query"

import {
  getContactConversations,
  getConversationTimeline,
  getOrganizations,
  searchContacts,
} from "../services/conversation-timeline-service"

export function useOrganizations() {
  return useQuery({
    queryKey: ["admin", "organizations"],
    queryFn: getOrganizations,
    staleTime: 5 * 60 * 1000,
  })
}

export function useContactSearch(query: string, organizationId?: string) {
  return useQuery({
    queryKey: ["admin", "contacts-search", query, organizationId],
    queryFn: () => searchContacts(query, organizationId),
    enabled: query.length >= 2,
    placeholderData: prev => prev,
  })
}

export function useContactConversations(contactId: string | undefined) {
  return useQuery({
    queryKey: ["admin", "contact-conversations", contactId],
    queryFn: () => getContactConversations(contactId!),
    enabled: !!contactId,
  })
}

export function useConversationTimeline(conversationId: string | undefined) {
  return useInfiniteQuery({
    queryKey: ["admin", "conversation-timeline", conversationId],
    queryFn: ({ pageParam }) =>
      getConversationTimeline(conversationId!, 50, pageParam as string | undefined),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => {
      if (!lastPage.has_more || lastPage.events.length === 0) return undefined
      return lastPage.events[lastPage.events.length - 1].timestamp
    },
    enabled: !!conversationId,
  })
}
